import { render } from "./RoomControlPois.vue?vue&type=template&id=a378a758&scoped=true"
import script from "./RoomControlPois.vue?vue&type=script&lang=js"
export * from "./RoomControlPois.vue?vue&type=script&lang=js"

import "./RoomControlPois.vue?vue&type=style&index=0&id=a378a758&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a378a758"]])

export default __exports__